import React from 'react';

const LevelCompleteModal = ({ showChoice, handleChoice, t }) => {
  if (!showChoice) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.5)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          background: '#fff6fa',
          padding: 32,
          borderRadius: 12,
          boxShadow: '0 2px 16px #f8bfcf20',
          textAlign: 'center',
        }}
      >
        <div style={{ fontSize: 20, marginBottom: 16, color: '#b85b7b' }}>
          {t('workout_complete', 'Workout Complete!')}
        </div>
        <div style={{ marginBottom: 24 }}>{t('progression_updated', 'Progression has been updated based on your AMRAP set.')}</div>
        <button
          className="pretty-btn"
          style={{ background: 'linear-gradient(90deg, #f7a8c7 0%, #f8bfcf 100%)' }}
          onClick={() => handleChoice(false)}
        >
          {t('done', 'Done')}
        </button>
      </div>
    </div>
  );
};

export default LevelCompleteModal;
